import React, { useEffect } from 'react';
import { SlPageTitle, SlButton } from '../editors';
import { Row, Col } from "reactstrap";
import { metadataService } from '../../_services';
import { newLoanActions } from "../../_actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";



const goodNews = (props) => {

    const handleContinue = () => {
        window.location.href = props.redirectURL;
    }

    useEffect(() => {
        let newLoanInfo = JSON.parse(sessionStorage.getItem("newloanInfo"));
        props.actions.soldNewLoan(newLoanInfo);
    }, [])

    return (
        <div>
            <SlPageTitle pageName="GoodNews" />
            <Row>
                <Col>
                    <p className={"text-center"}>{metadataService.getMessage("GoodNews")}
                        <strong>{metadataService.getMessage("Continue")}</strong>
                        {metadataService.getMessage("GoodNews2")}</p>
                </Col>
            </Row>
            <div className={"text-center"}>
                <SlButton name={"Continue"} size={"lg"} className={"text-center"} onClick={handleContinue} />
            </div>
        </div>
    )

};

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            soldNewLoan: (data) => {
                dispatch(newLoanActions.soldNewLoan(data));
            },
        }
    };
}

function mapStateToProps(store) {

    const { language } = store.users;


    return {
        language
    };
}


const GoodNews = withRouter(goodNews);
const connectedGoodNews = connect(mapStateToProps, mapDispatchToProps)(GoodNews);
export { connectedGoodNews as GoodNews };




// WEBPACK FOOTER //
// ./src/components/subcomponents/GoodNews.jsx